import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, Typography } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';
import styles from './styles';

const NoResultsScreen = ({ classes, showCompanyIcon }) => {
  return (
    <div className={classNames(classes.noResultsContainer)}>
      <ADGMImage name={showCompanyIcon ? 'CompanyNoResults.svg' : 'UserNoResults.svg'} alt='icon' />
      <Typography className={classNames(classes.title)}>{keyEmptyCheck('no_results_found')}</Typography>
      <Typography className={classNames(classes.subtitle)}>{keyEmptyCheck('user_inputs_verification_hint')}</Typography>
    </div>
  );
};

NoResultsScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  showCompanyIcon: PropTypes.bool.isRequired,
};

export default withStyles(styles)(NoResultsScreen);
